var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9567 4.9384C15.5423 4.35378 16.4908 4.35388 17.0763 4.93861L19.0582 6.91773C19.645 7.50376 19.6449 8.45479 19.058 9.04071L9.04379 19.0372C8.76256 19.3179 8.38143 19.4756 7.98407 19.4756H5.25C4.83579 19.4756 4.5 19.1398 4.5 18.7256V15.9987C4.5 15.6004 4.6584 15.2185 4.94028 14.9371L14.9567 4.9384ZM6.29168 15.8069C6.15073 15.9476 6.07152 16.1385 6.07152 16.3377V17.5312C6.07152 17.7383 6.23942 17.9062 6.44652 17.9062H7.64341C7.84208 17.9062 8.03264 17.8274 8.17325 17.687L14.8027 11.0697L12.9206 9.19014L6.29168 15.8069ZM17.3671 8.51002L15.9142 9.96024L14.0321 8.08068L15.4867 6.62876C15.7795 6.33647 16.2537 6.33652 16.5465 6.62888L17.3672 7.44851C17.6606 7.74153 17.6606 8.21706 17.3671 8.51002ZM18.2994 19.5019C18.7121 19.5019 19.0467 19.1673 19.0467 18.7546C19.0467 18.3419 18.7121 18.0073 18.2994 18.0073H13.0412C12.6285 18.0073 12.2939 18.3419 12.2939 18.7546C12.2939 19.1673 12.6285 19.5019 13.0412 19.5019H18.2994Z",
    fill: "#111B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.576133d079b29c59bea1977a1dbc5d50.svg";
export { ForwardRef as ReactComponent };